import React, { useState } from 'react';
import result from 'lodash/result';

import { GenericSpan } from 'commonStyles';
import { TableCell, TableRow } from './index';
import CheckBox from 'common/CheckBoxGrp/CheckBoxGrp';
import { AccordianWrapper, ReportingArrow } from './NestedRow.Styles';

const NestedRow = ({
	rowData,
	handleCheckBoxChange,
	columns,
	idKey = 'lineId',
	bodyRow,
	bodyRowChild,
	selectedRecords,
	index,
	data,
	childKey,
	isOpen,
	renderNestedChildren: RenderNestedChildren
}) => {
	const [open, setOpen] = useState(isOpen);
	const handleOpen = () => setOpen((prevState) => !prevState);
	const mainRowProps = rowData?.bodyCellProps || {};

	const childCount = rowData[childKey]?.length || 0;
	const getTxt = (actionLength) => `Show history (${actionLength})`;

	const getExpandConfig = ({ accessor, expandTrigger }) => {
		if (accessor === 'bookingId') {
			return {
				label: getTxt(childCount),
				arrowBorder: 'solid #008CFF',
				arrowRight: '-24px',
				arrowTop: open ? '6px' : '3px'
			};
		}
		if (expandTrigger) {
			return {
				label: null,
				arrowBorder: 'solid #757575',
				arrowRight: '-124px',
				arrowTop: open ? '-12px' : '-17px'
			};
		}
		return null;
	};

	return (
		<>
			<TableRow {...bodyRow}>
				{columns.map((column) => {
					const { accessor, bodyCellProps = {}, formatter, checkBoxColumn = false, noExpand, expandTrigger = false } = column;
					const value = !checkBoxColumn && result(rowData, accessor);
					const { bodyCellProps: cellDataProps = {} } = value || {};
					const id = rowData[idKey];

					let isChecked = false;
					if (checkBoxColumn) {
						isChecked = selectedRecords ? !!selectedRecords[id] : rowData.checked;
					}
					const cellProps = { ...mainRowProps, ...bodyCellProps, ...cellDataProps };
					const expandConfig = childCount > 0 && !noExpand ? getExpandConfig({ accessor, expandTrigger }) : null;
					return (
						<TableCell {...cellProps} key={accessor}>
							{checkBoxColumn ? (
								<CheckBox
									item=''
									isChecked={isChecked}
									handleChange={handleCheckBoxChange(false, rowData)}
								/>
							) : formatter ? formatter(value, rowData, index, column, data) : value}
							{expandConfig &&
								<AccordianWrapper
									onClick={handleOpen} fsize='11px' color='#008ccf' f_weight='700'>
									{expandConfig.label}
									<GenericSpan position='relative'>
										<ReportingArrow open={open} border={expandConfig.arrowBorder} right={expandConfig.arrowRight} $top={expandConfig.arrowTop} />
									</GenericSpan>
								</AccordianWrapper>}
						</TableCell>
					);
				})}
			</TableRow>
			{open && (
				<>
					{RenderNestedChildren ? (
						<TableRow {...bodyRowChild}>
							<TableCell colSpan={columns.length} variant='child' noBdr padding='none' bdr='16px' noBg>
								<RenderNestedChildren services={rowData[childKey]} idKey={idKey} parentRow={rowData} />
							</TableCell>
						</TableRow>
					) : (
						rowData[childKey].map((rowChild, i) => (
							<TableRow key={rowChild[idKey]} {...bodyRowChild}>
								{columns.map((column) => {
									const { accessor, bodyCellProps = {}, formatter, checkBoxColumn = false } = column;
									const value = !checkBoxColumn && result(rowChild, accessor);
									const subRowProps = rowChild.bodyCellProps || {};
									const { bodyCellProps: cellDataProps = {} } = value || {};
									const cellProps = { ...mainRowProps, ...subRowProps, ...bodyCellProps, ...cellDataProps };
									const isLast = rowData[childKey]?.length - 1 === i;
									return (
										<TableCell {...cellProps} key={accessor} variant='child' noBdr={isLast ? false : true}>
											{formatter ? formatter(value, rowChild, index, column, data) : value}
										</TableCell>
									);
								})}
							</TableRow>
						))
					)}
				</>
			)}
		</>
	);
};

export default NestedRow;
